import React, { useState, useEffect, Fragment } from "react"
import MetaTags from 'react-meta-tags';
import { useSelector } from "react-redux";

import { useLocation, useHistory } from "react-router-dom"
import { Container, Row, Col, Button, Input, Label, Card, CardBody, InputGroup } from "reactstrap"

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"

import coloredCorrespondent from "../../assets/images/svg/correspondent_color.svg"
import Modal from "components/RopikCustom/Modal";
import ExplanationBox from "pages/Custom/ExplanationBox";

// 주소 찾기
import DaumPostcode from 'react-daum-postcode';
import { getCollectZoneList, getDriverList, getCarList } from "crud/search.crud";
import SelectBox from "components/RopikCustom/SelectBox";
import { companyListCall } from "crud/auth.crud";
import { save } from "crud/auth.crud";
import { updateClientData, getClientDetailData } from "../../crud/contact.crud";
import moment from 'moment';

const emitterTypeItem = [
  {text: '일반 배출자', value: 'single'},
  {text: '배출신고자', value: 'report'},
  {text: '다량 배출자', value: 'many'},
  {text: '대수(통합) 배출자', value: 'multi'},
]

const sendingItem1 = [
  {text: '회사메일 1', key: 'company1'},
  {text: '회사메일 2', key: 'company2'},
  {text: '담당자 메일', key: 'manager'},
]

const payMethod = [
      { 'id' : 'card', 'name' : '신용카드'},
      { 'id' : 'trans', 'name' : '계좌이체'},            
      { 'id' : 'phone', 'name' : '휴대폰결제'},
  ]
  
const bankList = [
      {'id' : '002', 'name' : '산업은행'},
      {'id' : '003', 'name' : '기업은행'},
      {'id' : '004', 'name' : '국민은행'},
      {'id' : '007', 'name' : '수협중앙회'},
      {'id' : '020', 'name' : '농협은행'},
      {'id' : '023', 'name' : 'SC은행'},
      {'id' : '027', 'name' : '한국씨티은행'},
      {'id' : '031', 'name' : '대구은행'},
      {'id' : '032', 'name' : '부산은행'},
      {'id' : '034', 'name' : '광주은행'},
      {'id' : '035', 'name' : '제주은행'},
      {'id' : '037', 'name' : '전북은행'},
      {'id' : '039', 'name' : '경남은행'},
      {'id' : '045', 'name' : '새마을금고'},
      {'id' : '048', 'name' : '신협중앙회'},
      {'id' : '071', 'name' : '우체국'},
      {'id' : '081', 'name' : 'KEB하나은행'},
      {'id' : '088', 'name' : '신한은행'},
      {'id' : '209', 'name' : '유안타증권'},
      {'id' : '240', 'name' : '삼성증권'},
      {'id' : '089', 'name' : '케이뱅크'},
  ]


const initInputCondition = {
  // 배출자 기초정보
  company_id : '',
  company_detail_id : '',
  emitterType: 'single',
  businessName: '',
  tradeName: '',
  businessNumber: '',
  representative: '',
  representativeHP: '',
  representativeEmail1: '',
  representativeEmail2: '',
  zipCode: '',
  companyAddress1: '',
  companyAddress2: '',
  realZipCode: '',
  realCompanyAddress1: '',
  realCompanyAddress2: '',
  industry: '',
  businessStatus: '',
  ID: '',
  PW: '',
  olbaroID: '',
  olbaroPW: '',

  // 담당자 기초정보
  managerName: '',
  managerDepartment: '',
  managerPosition: '',
  managerHP: '',
  managerFax: '',
  managerEmail: '',
  managerLandlinePhone: '',

  // 과금 기준정보
  contract_id : '',
  paymentMethod: '',
  invoicing: '',
  settlementDate: 1,
  vat: '',
  ratePlan: '',
  unitPrice: '',
  baseRate: '',
  baseLiter: '',
  correspondentSize: '',
  unit: '',
  collection_container_fee: '',
  security: '',
  certificate_report_date: '',
  certificate_report_number: '',
  billing_content: '',
  area_rate: '',
  classification: '',
  is_report: '',
  prevention_method: '',

  // CMS 정보
  cms_id : '',
  CMSNumber: '',
  CMSBirthAndName: '',
  CMSBank: '',
  CMSDepositor: '',
  CMSAccountNumber: '',
  joinDate : '',

  // 메일/SMS 발송
  tax_mail: { company1: 'Y', company2: 'N', manager: 'Y'},
  charge_report: { company1: 'Y', company2: 'N', manager: 'Y'},
  charge_sms: { company1: 'Y', company2: 'N'},
  unpaid_sms: { company1: 'Y', company2: 'N'},
  collect_alert: { company1: 'Y', company2: 'N'},
  collect_alert_exclude_qty: { company1: 'Y', company2: 'N'},


  // 계약 정보
  contractCategory: '',
  contractDate: '',
  startDate: '',
  endDate: '',

  // 메모
  memo: '',
};

const sendingItem2 = sendingItem1.slice(0, -1);

const daySelect = [
  ...Array(28).keys()
].map(x => x + 1)


const style = { backgroundColor: "#ffffff", padding: "0.5rem", cursor: "pointer", width: '466px', border: '1px solid #bdbdbd', marginTop : '0.5rem', borderRadius: '4px', color : '#333'  };

const hoverStyle = { backgroundColor: "#4DBBAA", color: "#ffffff", width: '466px', border: '1px solid #4DBBAA' };



const correspondentEdit = () => {
  const location = useLocation()
  const history = useHistory()
  const code = useSelector((state) => state.Data?.code[0] || [])
  const selector = useSelector(state => state)  
  const companyData = selector.auth?.user?.member_group?.[0]?.company_group;
  const [desiredCollectionDays, setdesiredCollectionDays] = useState([])
  const [weeks, setWeeks] = useState([])
  const [collectZoneData, setCollectZoneData] = useState([]);
  const [driverData, setDriverData] = useState([]);  
  const [carData, setCarData] = useState([]);  
  const [isHover, setIsHover] = useState(false); // 계약처 선택 시 마우스 호버 상태
  const [company, setCompany] = useState(null);
  const [companies, setCompanies] = useState(companyData.type === 'treatment' ? [companyData] : []);
  const [companyList, setCompanyList] = useState([]);
  const [page, setPage] = useState(1);
  const [search, setSearch] = useState('');
  const [oldCmsFile, setOldCmsFile] = useState([]);  
  const [oldCertificateFiles, setOldCertificateFiles] = useState([])
  const [correspondentSize, setCorrespondentSize] = useState([])
  const [cmsFile, setCmsFile] = useState([]);    
  const [detailData, setDetailData] = useState({});

  const handleSearch = (str) => {
    if (str === 'treatment') {
      setCompanyList([])
      getCompanyList()
    }
  }

  useEffect(() => {
    if (code.length > 0) {
      setWeeks(code.filter((item) => item.code === 'weeks'))
    }
  }, [code])

  const handledesiredCollectionDays = (item, num) => {    
    setdesiredCollectionDays((prev) => {
      // 이미 선택된 item 이 있는지 확인
      if (prev.some((itm) => itm.key === item.key)) {
        // 있으면 제거
        return prev.filter((value) => value.key !== item.key)
      } else if (prev.length < num) {
        // 없고, 개수가 num보다 작으면 추가
        return [...prev, item]
      }
      // 그 외에는 변경 없음
      return prev
    })
  }

  const [inputItem, setInputItem] = useState(initInputCondition)
  const [modalShow, setModalShow] = useState({
    post : false
  })
  const [explanationBox, setExplanationBox] = useState({
    emitter : false,
    olbaro : false,
    correspondent : false,
    prevention_method : false
  })
  const [contractFiles, setContractFiles] = useState([])
  const [certificateFiles, setCertificateFiles] = useState([])

  const [onUpload, setOnUpload] = useState([])
  const resetSearchCondition = () => {
    setInputItem(initInputCondition)
  }

  const changeInputCondition = (key, value) => {
    setInputItem(prev => ({...prev, [key]: value}))
  }

  const changeCheckInputCondition = (parentKey, childKey, value) => {
    setInputItem(prev => ({
      ...prev,
      [parentKey]: {
        ...(prev[parentKey] || {}),
        [childKey]: value ? 'Y' : 'N'
      }
    }))
  }

  const isValidated = () => {    
    // if (!(inputItem.emitterType && inputItem.businessName && inputItem.tradeName && inputItem.businessNumber && inputItem.representative && inputItem.representativeHP && inputItem.representativeEmail1 && inputItem.representativeEmail2 && inputItem.zipCode && inputItem.companyAddress1 && inputItem.companyAddress2 && inputItem.paymentMethod && inputItem.invoicing && inputItem.settlementDate && inputItem.vat && inputItem.ratePlan && inputItem.unitPrice && inputItem.baseRate && inputItem.baseLiter && inputItem.correspondentSize && inputItem.unit && inputItem.collect_zone && inputItem.car && inputItem.day_of_week && inputItem.contractCategory && inputItem.contractDate && inputItem.startDate && contractFiles.length > 0)) {
    //   alert("'●' 표시가 되어있는 란은 모두 기입해 주세요.")
    //   return false
    // }
    return true
  }

  const saveCorrespondent = async() => {
        
        setOnUpload(true)
    
        try {
            const fd = new FormData();

            fd.append('cms_file', cmsFile[0])
            fd.append('company_file', certificateFiles[0])

            const companyParams = { 
              id : inputItem?.company_id,            
              name: inputItem?.businessName || '',
              name2: inputItem?.tradeName || '',
              company_number: inputItem?.businessNumber || '',
              username: inputItem?.representative || '',
              mobile_phone: inputItem?.representativeHP || '',
              email: inputItem?.representativeEmail1 || '',
              email2: inputItem?.representativeEmail2 || '',
              zipcode: inputItem?.zipCode || '',
              address1: inputItem?.companyAddress1 || '',
              address2: inputItem?.companyAddress2 || '',
              real_zipcode: inputItem?.realZipCode || '',
              real_address1: inputItem?.realCompanyAddress1 || '',
              real_address2: inputItem?.realCompanyAddress2 || '',  
              allbaro_id: inputItem?.olbaroID || '',
              allbaro_pw: inputItem?.olbaroPW || '',
              r_name: inputItem?.managerName || '',
              r_department: inputItem?.managerDepartment || '',
              r_position: inputItem?.managerPosition || '',
              r_mobile_phone: inputItem?.managerHP || '',
              fax: inputItem?.managerFax || '',
              r_email: inputItem?.managerEmail || '',
              phone: inputItem?.managerLandlinePhone || '',
            }

            const companyDetailParams = {
              id : inputItem?.company_detail_id,
              type: inputItem?.emitterType || '',
              sector: inputItem?.industry || '',
              sector2: inputItem?.businessStatus || '',
              collection_day: JSON.stringify(desiredCollectionDays || []),
            }            

            const contractParams = {
              id : inputItem?.contract_id,
              payment_type: inputItem?.paymentMethod || '',
              receipt_type: inputItem?.invoicing || 'Y',
              settlement_date: inputItem?.settlementDate || 1,
              is_vat: inputItem?.vat || 'Y',
              billing_type: inputItem?.ratePlan || 'P',
              price_per_l: inputItem?.unit == 'l' ? inputItem?.unitPrice : '0',
              price_per_kg: inputItem?.unit != 'l' ? inputItem?.unitPrice : '0',
              min_price: inputItem?.baseRate || '70000',
              min_l: inputItem?.unit == 'l' ? inputItem?.baseLiter : '0',
              min_kg: inputItem?.unit != 'l' ? inputItem?.baseLiter : '0',
              client_type: inputItem?.correspondentSize || 'Y',
              collect_type: inputItem?.unit || 'l',
              collection_day: JSON.stringify(desiredCollectionDays || []),              
              collection_container_fee: inputItem?.collection_container_fee || '0',
              deposit_amount: inputItem?.deposit_amount || '0',
              certificate_report_date: inputItem?.certificate_report_date || '',
              certificate_report_number: inputItem?.certificate_report_number || '',
              billing_content: inputItem?.billing_content || '',
              area_rate: inputItem?.area_rate || '0',              
              is_report: inputItem?.is_report || 'Y',
              prevention_method: inputItem?.prevention_method || '밀폐 용기로 보관 후 일괄 배출',
              tax_mail: JSON.stringify(inputItem?.tax_mail || { "company1": "Y", "company2": "N", "manager": "Y" }),
              charge_report: JSON.stringify(inputItem?.charge_report || { "company1": "Y", "company2": "N", "manager": "Y" }),
              charge_sms: JSON.stringify(inputItem?.charge_sms || { "company1": "Y", "company2": "N" }),
              unpaid_sms: JSON.stringify(inputItem?.unpaid_sms || { "company1": "Y", "company2": "N" }),
              collect_alert: JSON.stringify(inputItem?.collect_alert || { "company1": "Y", "company2": "N" }),
              collect_alert_exclude_qty: JSON.stringify(inputItem?.collect_alert_exclude_qty || { "company1": "Y", "company2": "N" }),
              contract_date: inputItem?.contractDate || '',
              start_date: inputItem?.startDate || '',
              end_date: inputItem?.endDate || '',
              memo: inputItem?.memo || '',
            }
            

            const cmsParams = {
              id : inputItem.cms_id,
              cms_user_id: inputItem?.CMSNumber || "",
              cms_data: JSON.stringify({
                "memberId": inputItem?.CMSNumber || "",
                "memberName": inputItem?.representative || "",
                "smsFlag": "N",
                "phone": inputItem?.representativeHP || "",
                "email": inputItem?.representativeEmail1 || "",
                "zipcode": inputItem?.zipCode || "",
                "address1": inputItem?.companyAddress1 || "",
                "address2": inputItem?.companyAddress2 || "",
                "joinDate": moment().format('YYYYMMDD'),
                "receiptFlag": "Y",
                "receiptNumber": inputItem?.representativeHP || "",
                "memberKind": "",
                "managerId": "",
                "memo": "",
                "paymentStartDate": "",
                "paymentEndDate": "",
                "paymentDay": inputItem?.settlementDate || "01",
                "defaultAmount": inputItem?.vat == 'Y' ? inputItem?.baseRate * 1.1 : inputItem?.baseRate,
                "paymentKind": "CMS",
                "paymentCompany": inputItem?.CMSBank || "",
                "paymentNumber": inputItem?.CMSAccountNumber || "",
                "payerName": inputItem?.CMSDepositor || "",
                "payerNumber": inputItem?.CMSBirthAndName || "",                
              }),              
            }
                
            
            fd.append('company_params', JSON.stringify(companyParams))            
            fd.append('company_detail_params', JSON.stringify(companyDetailParams))
            fd.append('contract_params', JSON.stringify(contractParams))            
            fd.append('cms_params', JSON.stringify(cmsParams))
    
            const response = await updateClientData(fd);
            if(response.data?.result === 'success'){ 
              setOnUpload(false)
              alert(response.data.msg)

            }else{
              setOnUpload(false)
            }             
           
        } catch (e) {
          setOnUpload(false)
          console.log(e)
        }
  }

  const modalOpen = (key) => {
    setModalShow(prev => ({...prev, [key]: true}))
  }

  const modalClose = (key) => {
    setModalShow(prev => ({...prev, [key]: false}))
  }

  const explanationOn = async(str) => {
    setExplanationBox(prev => ({...prev, [str] : !prev[str]}))
  }

  const registContract = (files) => {    
    const limitedFiles = [...files].slice(0, 5);
    setContractFiles(limitedFiles);
  }

  const registCertificate = (files) => {
    setCertificateFiles(files);
  }

  const registCmsFile = (files) => {
    setCmsFile(files);
  }

  // 주소찾기 API
  const Post = () => {

    const complete = (data) =>{
      // data.zonecode는 우편번호, data.roadAddress는 도로명주소
      let zipAddress = data.zonecode;
      let roadAddress = data.roadAddress;
      modalClose('post')
      
      changeInputCondition('zipCode', zipAddress)
      changeInputCondition('companyAddress1', roadAddress)
    }

    return (
      <div>
        <DaumPostcode
          className="postmodal"
          autoClose
          onComplete={complete} />
      </div>
    );
  };

  // 주소찾기 API
  const RealPost = () => {

    const complete = (data) =>{
      // data.zonecode는 우편번호, data.roadAddress는 도로명주소
      let zipAddress = data.zonecode;
      let roadAddress = data.roadAddress;
      modalClose('realPost')
      
      changeInputCondition('realZipCode', zipAddress)
      changeInputCondition('realCompanyAddress1', roadAddress)
    }

    return (
      <div>
        <DaumPostcode
          className="postmodal"
          autoClose
          onComplete={complete} />
      </div>
    );
  };

  const getDriverDataList = async () => {    
    try {
      const response = await getDriverList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setDriverData([...content])
        } else {
          setDriverData([])
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCarDataList = async () => {
    try {
      const response = await getCarList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCarData([...content])
        } else {
          setCarData([])      
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

  const getCollectZoneDataList = async () => {
    try {
      const response = await getCollectZoneList();
      if (response.status === 200) {
        const content = response.data?.data || [];
        if (content.length > 0) {
          setCollectZoneData([...content])
        } else {
          setCollectZoneData([])      
        }
      }
    } catch (error) {
      console.error(error);
    }
  }

   const getCompanyList = async () => {
      const params = {
        page: page,
        type: 'treatment',
        search: search
      }
      const rs = await companyListCall(params)
      if (rs.status === 200) {
        if(rs?.data?.count <= 15){
          const content = rs?.data?.results
          if (content.length > 0) {
            setCompanyList([...content])
          } else {
            setCompanyList([])
          }
        }else{
          const content = rs?.data?.results || []
          let contentSum = [...content]
          let pageTotal = Math.floor(rs?.data?.count/15);
          for(let i=2; i<=pageTotal+1; i++){
            const param = {
              page: i,
              type: 'treatment',
              search: search
            }
            const response = await companyListCall(param)
            if(response.status === 200){
              let plusContent = response?.data?.results || []
              contentSum = [...contentSum, ...plusContent]
            }
          }
          setCompanyList([...contentSum])
        }
      }
    }

  const makeCodeArr = (str, callback) =>{
    let codes = code.filter(itm => itm.code == str)
    let tmp = []
    for (let i=0; i< codes.length; i++){
      let itm = {
        id : codes[i]?.key,
        name: codes[i]?.text
      }
      tmp.push(itm)
    }
    callback(tmp)
  }

  const getDetailData = async () => {
      const params = {
        company: location.state?.company?.id,        
        contract: location.state?.contract?.id,        
      }
      const rs = await getClientDetailData(params)
      if (rs.status === 200) {
        const company_data = rs?.data?.data?.company
        const contract_data = rs?.data?.data?.contract
        const cms_data = rs?.data?.data?.cms?.cms_data ? JSON.parse(rs?.data?.data?.cms?.cms_data) : {}
        const cms_file_data = rs?.data?.data?.cms
        const company_file_data = rs?.data?.data?.company_file

        setOldCmsFile(cms_file_data)
        setOldCertificateFiles(company_file_data)

        const item = {
          company_id : company_data?.id,
          company_detail_id : company_data?.company_detail?.id,
          contract_id : contract_data?.id,
          cms_id : cms_file_data?.id,
          businessName : company_data?.name || '',
          tradeName : company_data?.name2 || '',
          businessNumber : company_data?.company_number || '',
          representative : company_data?.username || '',
          representativeHP : company_data?.mobile_phone || '',
          representativeEmail1 : company_data?.email || '',
          representativeEmail2 : company_data?.email2 || '',
          zipCode : company_data?.zipcode || '',
          companyAddress1 : company_data?.address1 || '',
          companyAddress2 : company_data?.address2 || '',
          realZipCode : company_data?.real_zipcode || '',
          realCompanyAddress1 : company_data?.real_address1 || '',
          realCompanyAddress2 : company_data?.real_address2 || '',
          olbaroID : company_data?.allbaro_id || '',
          olbaroPW : company_data?.allbaro_pw || '',
          managerName : company_data?.r_name || '',
          managerDepartment : company_data?.r_department || '',
          managerPosition : company_data?.r_position || '',
          managerHP : company_data?.r_mobile_phone || '',
          managerFax : company_data?.fax || '',
          managerEmail : company_data?.r_email || '',
          managerLandlinePhone : company_data?.phone || '',      
          emitterType : company_data?.company_detail?.type || '',     
          industry : company_data?.company_detail?.sector || '',     
          businessStatus : company_data?.company_detail?.sector2 || '',     
          desiredCollectionDays : contract_data?.collection_day ? JSON.parse(contract_data?.collection_day) : [], 
          paymentMethod : contract_data?.payment_type || '',
          invoicing : contract_data?.receipt_type || '',
          settlementDate : contract_data?.settlement_date || 1,
          vat : contract_data?.is_vat || '',
          ratePlan : contract_data?.billing_type || '',
          unit : contract_data?.collect_type || '',
          unitPrice : contract_data?.collect_type == 'l' ? contract_data?.price_per_l : contract_data?.price_per_kg,
          baseRate : contract_data?.min_price,
          baseLiter : contract_data?.collect_type == 'l' ? contract_data?.min_l : contract_data?.min_kg,
          correspondentSize : contract_data?.client_type || '',
          collection_container_fee : contract_data?.collection_container_fee || '',
          deposit_amount : contract_data?.deposit_amount,
          certificate_report_date : contract_data?.certificate_report_date || '',
          certificate_report_number : contract_data?.certificate_report_number || '',
          billing_content : contract_data?.billing_content || '',
          area_rate : contract_data?.area_rate || '',
          is_report : contract_data?.is_report || '',
          prevention_method : contract_data?.prevention_method || '',
          tax_mail : contract_data?.tax_mail ? JSON.parse(contract_data?.tax_mail) : { "company1": "Y", "company2": "N", "manager": "Y" },
          charge_report : contract_data?.charge_report ? JSON.parse(contract_data?.charge_report) : { "company1": "Y", "company2": "N", "manager": "Y" },
          charge_sms : contract_data?.charge_sms ? JSON.parse(contract_data?.charge_sms) : { "company1": "Y", "company2": "N" },
          unpaid_sms : contract_data?.unpaid_sms ? JSON.parse(contract_data?.unpaid_sms) : { "company1": "Y", "company2": "N" },
          collect_alert : contract_data?.collect_alert ? JSON.parse(contract_data?.collect_alert) : { "company1": "Y", "company2": "N" },
          collect_alert_exclude_qty : contract_data?.collect_alert_exclude_qty ? JSON.parse(contract_data?.collect_alert_exclude_qty) : { "company1": "Y", "company2": "N" },
          contractDate : contract_data?.contract_date || '',
          startDate : contract_data?.start_date || '',
          endDate : contract_data?.end_date || '',
          memo : contract_data?.memo || '',    
          CMSNumber : cms_data?.memberId || '',   
          joinDate : cms_data?.joinDate || moment().format('YYYYMMDD'),   
          CMSBank : cms_data?.paymentCompany || '',   
          CMSAccountNumber : cms_data?.paymentNumber || '',   
          CMSDepositor : cms_data?.payerName || '',   
          CMSBirthAndName : cms_data?.payerNumber || '',   
        }
        console.log(item)
        setInputItem(item)

      }
    }

  useEffect(()=>{
    getCompanyList()
    getCollectZoneDataList()
    getDriverDataList()
    getCarDataList()
    makeCodeArr('client_type', setCorrespondentSize)

    getDetailData()
  },[])

  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>계약관리 / 웨이스트버스</title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs maintitle="Home" title="계약관리" breadcrumbItem="거래처 수정" />

          <div className="d-flex align-items-center margin-bottom-12">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">사업자 기초정보</p>
          </div>
          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text padding-right-8">
                            <div className="d-flex align-items-center justify-content-between">
                              ● 배출자 구분
                              <i className="ti-help-alt position-relative" onClick={() => {
                                explanationOn('emitter')
                              }}>
                                {explanationBox.emitter &&
                                  <ExplanationBox
                                    title={'배출자 구분 설명'}
                                    text={'① 일반 : 배출 미 신고 사업장\n② 배출자 : 배출 사업자 신고 필요, 일 300kg 이상 배출자\n③ 다량 배출자 : 감량 사업자, 발생 억재처리 신고 의무\n④ 다수(통합 배출자) : 한 사업자에 여러 업체가 있는 경우\n\n※ 사업자등록증상의 상호와 실제 상호가 다르거나 하나의 프랜차이즈에 여러 지점이 등록된 경우, "상호(관리용), 다수(통합) 배출자"에 실제 사업장명 및 프랜차이즈명 입력'}
                                    top={-88}
                                  />
                                }
                              </i>
                            </div>
                          </td>
                          <td colSpan="4">
                            {emitterTypeItem.map((item, index) => (
                              <div className="form-check form-check-inline" key={'emitter_type_item_'+index}>
                                <input id={'emitter_type_item_'+index} className="is-untouched is-pristine av-valid form-check-input" checked={inputItem.emitterType === item.value} type="radio" name="emitters" value={item.value} onChange={(e) => {
                                  changeInputCondition('emitterType', e.target.value)
                                }} />
                                <label className="margin-bottom-0 form-check-label font-size-16 text-black" htmlFor={'emitter_type_item_'+index} >{item.text}</label>
                              </div>
                            ))}
                          </td> 
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 사업자명</td>
                          <td className="w-40">
                            <input className='waver-input-box w-40 border-radius-0 margin-right-4' value={inputItem.businessName} placeholder="사업자등록증 상 사업자명" onChange={(e) => {
                              changeInputCondition('businessName', e.target.value)
                            }} />
                            <input className='waver-input-box w-40 border-radius-0' value={inputItem.tradeName} placeholder="상호 (관리용, 다수(통합) 배출자)" onChange={(e) => {
                              changeInputCondition('tradeName', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 사업자 번호</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.businessNumber} placeholder="000-00-0000" onChange={(e) => {
                              changeInputCondition('businessNumber', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 대표자명</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.representative} placeholder="대표자명을 입력하세요." onChange={(e) => {
                              changeInputCondition('representative', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 대표자 HP</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.representativeHP} placeholder="000-0000-0000" onChange={(e) => {
                              changeInputCondition('representativeHP', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 대표자 Email 1</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.representativeEmail1} placeholder="회사메일1을 입력하세요." onChange={(e) => {
                              changeInputCondition('representativeEmail1', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 대표자 Email 2</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.representativeEmail2} placeholder="회사메일2을 입력하세요." onChange={(e) => {
                              changeInputCondition('representativeEmail2', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text padding-right-8">● 사업장주소</td>
                          <td colSpan="4">
                            <button type="button" className="custom-btn tertiary-bg w-10 border-radius-0 white-text border-none margin-right-4" onClick={() => {
                              modalOpen('post')
                            }}>
                              우편번호 찾기
                            </button>
                            <input className='waver-input-box w-8 border-radius-0 margin-right-4' value={inputItem.zipCode} disabled placeholder="우편번호" />
                            <input className='waver-input-box w-30 border-radius-0 margin-right-4' value={inputItem.companyAddress1} disabled placeholder="주소" />
                            <input className='waver-input-box w-30 border-radius-0' value={inputItem.companyAddress2} placeholder="상세 주소" onChange={(e) => {
                              changeInputCondition('companyAddress2', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text padding-right-8">사업장 실제주소</td>
                          <td className="w-90" colSpan="4">
                            <button type="button" className="custom-btn tertiary-bg w-10 border-radius-0 white-text border-none margin-right-4" onClick={() => {
                              modalOpen('realPost')
                            }}>
                              우편번호 찾기
                            </button>
                            <input className='waver-input-box w-8 border-radius-0 margin-right-4' value={inputItem.realZipCode} disabled placeholder="우편번호" />
                            <input className='waver-input-box w-30 border-radius-0 margin-right-4' value={inputItem.realCompanyAddress1} disabled placeholder="주소" />
                            <input className='waver-input-box w-30 border-radius-0' value={inputItem.realCompanyAddress2} placeholder="상세 주소" onChange={(e) => {
                              changeInputCondition('realCompanyAddress2', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text padding-right-8">사업자 등록증</td>
                          <td className="w-90" colSpan="4">
                            <div className="d-flex align-items-center">
                              <input className="d-none" accept=".pdf" type="file" id="certificate" onChange={(e)=>{
                                registCertificate(e.target.files)
                              }}/>
                              <label style={{width: 113}} htmlFor="certificate" type="button" className="custom-btn border-radius-0 tertiary-bg white-text mb-0 text-center">
                                파일 첨부
                              </label>
                              {certificateFiles?.[0] ?
                                <p className="mb-0">{certificateFiles[0].name}</p> 
                                :
                                oldCertificateFiles?.[0] ? 
                                  <p className="mb-0">{oldCertificateFiles[0].name}</p> 
                                  :
                                  <p className="mb-0"></p> 
                              }
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">업종</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.industry} placeholder="업종을 입력하세요." onChange={(e) => {
                              changeInputCondition('industry', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">업태</td>
                          <td className="w-40">
                            <input className='waver-input-box w-80 border-radius-0' value={inputItem.businessStatus} placeholder="업태를 입력하세요." onChange={(e) => {
                              changeInputCondition('businessStatus', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>                         
                          <td className="w-10 padding-left-8 primary-bg white-text padding-right-8">
                            <div className="d-flex align-items-center justify-content-between">
                              올바로 ID / PW
                              <i className="ti-help-alt position-relative" onClick={() => {
                                explanationOn('olbaro')
                              }}>
                                {explanationBox.olbaro &&
                                  <ExplanationBox
                                    title={'올바로 ID/PW 입력'}
                                    text={'올바로 배출자 신고 사업자의 경우, "배출 신고 사업자"의 경우 올바로 ID 및 PW는 필수 입력 값'}
                                    top={-39}
                                  />
                                }
                              </i>
                            </div>
                          </td>
                          <td className="w-40">
                            <input className='waver-input-box w-40 border-radius-0 margin-right-4' value={inputItem.olbaroID} placeholder="올바로 ID를 입력해 주세요." onChange={(e) => {
                              changeInputCondition('olbaroID', e.target.value)
                            }} />
                            <input className='waver-input-box w-40 border-radius-0' value={inputItem.olbaroPW} placeholder="비밀번호를 입력해 주세요." onChange={(e) => {
                              changeInputCondition('olbaroPW', e.target.value)
                            }} />
                          </td>
                           <td className="w-10 padding-left-8 primary-bg white-text"></td>
                          <td className="w-40">                            
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center margin-bottom-12 margin-top-38">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">담당자 기초정보</p>
          </div>
          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">담당자명</td>
                          <td className="w-40">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.managerName} placeholder="담당자명을 입력해 주세요." onChange={(e) => {
                              changeInputCondition('managerName', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">부서 / 직책</td>
                          <td className="w-40">
                            <input className='waver-input-box w-40 border-radius-0 margin-right-4' value={inputItem.managerDepartment} placeholder="부서" onChange={(e) => {
                              changeInputCondition('managerDepartment', e.target.value)
                            }} />
                            <input className='waver-input-box w-40 border-radius-0' value={inputItem.managerPosition} placeholder="직책" onChange={(e) => {
                              changeInputCondition('managerPosition', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">HP</td>
                          <td className="w-40">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.managerHP} placeholder="HP 번호를 입력해 주세요." onChange={(e) => {
                              changeInputCondition('managerHP', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">FAX</td>
                          <td className="w-40">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.managerFax} placeholder="팩스번호를 입력해 주세요." onChange={(e) => {
                              changeInputCondition('managerFax', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">E-mail</td>
                          <td className="w-40">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.managerEmail} placeholder="E-mail 주소를 입력해 주세요." onChange={(e) => {
                              changeInputCondition('managerEmail', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">유선번호</td>
                          <td className="w-40">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.managerLandlinePhone} placeholder="유선 전화번호를 입력해 주세요." onChange={(e) => {
                              changeInputCondition('managerLandlinePhone', e.target.value)
                            }} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center margin-bottom-12 margin-top-38">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">과금 기준정보</p>
          </div>
          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 결제수단</td>
                          <td className="w-15">
                            <SelectBox
                                value={inputItem?.paymentMethod}
                                onChange={changeInputCondition}
                                options={payMethod}
                                keyValue={'paymentMethod'}
                              />                            
                          
                            {/* <select className='waver-select-box w-100 border-radius-0' value={inputItem.paymentMethod} onChange={(e) => {
                              changeInputCondition('paymentMethod', e.target.value)
                            }}>
                              <option value="deposit">{'계좌입금'}</option>
                              <option value="card">{'카드'}</option>
                            </select> */}
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 계산서 발급</td>
                          <td className="w-15">
                            <select className='waver-select-box w-100 border-radius-0' value={inputItem.invoicing} onChange={(e) => {
                              changeInputCondition('invoicing', e.target.value)
                            }}>
                              <option value="Y">{'계산서 발급'}</option>
                              <option value="N">{'계산서 미발급'}</option>
                            </select>
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 결산일</td>
                          <td className="w-15">
                            <select className='waver-select-box w-100 border-radius-0' value={inputItem.settlementDate} onChange={(e) => {
                              changeInputCondition('settlementDate', e.target.value)
                            }}>
                              {daySelect.map((item, index) => (
                                <option key={'settlement_date_'+index} value={item}>{item}일</option>
                              ))}
                            </select>
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 부가세옵션</td>
                          <td className="w-15">
                            <select className='waver-select-box w-100 border-radius-0' value={inputItem.vat} onChange={(e) => {
                              changeInputCondition('vat', e.target.value)
                            }}>
                              <option value="Y">{'부가세 포함'}</option>
                              <option value="N">{'부가세 미포함'}</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 요금제</td>
                          <td className="w-15">
                            <select className='waver-select-box w-100 border-radius-0' value={inputItem.ratePlan} onChange={(e) => {
                              changeInputCondition('ratePlan', e.target.value)
                            }}>
                              <option value="F">{'정액제'}</option>
                              <option value="P">{'종량제'}</option>
                            </select>
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 단가</td>
                          <td className="w-15">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.unitPrice} placeholder="단가" onChange={(e) => {
                              changeInputCondition('unitPrice', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 기본료</td>
                          <td className="w-15">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.baseRate} placeholder="기본료" onChange={(e) => {
                              changeInputCondition('baseRate', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 기본리터</td>
                          <td className="w-15">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.baseLiter} placeholder="기본리터" onChange={(e) => {
                              changeInputCondition('baseLiter', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">수거용기 대금</td>
                          <td className="w-15">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.collection_container_fee} placeholder="수거용기 대금" onChange={(e) => {
                              changeInputCondition('collection_container_fee', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">보증금</td>
                          <td className="w-15">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.security} placeholder="보증금" onChange={(e) => {
                              changeInputCondition('security', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">
                            <div className="d-flex align-items-center justify-content-between">
                              ● 신고대상여부
                              <i className="ti-help-alt position-relative" onClick={() => {
                                explanationOn('correspondent')
                              }}>
                                {explanationBox.correspondent &&
                                  <ExplanationBox
                                    title={'거래처 규모 설명'}
                                    text={'다량 배출사업자\n‧ 배출량 300kg/일 이상\n‧ 영업장 면적 200㎡ 이상인 휴게 및 일반음식점\n‧ 급식 인원 100명 이상인 집단 급식소\n‧ 대규모 점포(매장면적 3,000㎡ 이상)\n‧ 농수산물센터(도매시장, 공판장, 종합유통센터)\n‧ 관광숙박시설(호텔, 콘도미디엄)'}
                                    top={-80}
                                  />
                                }
                              </i>
                            </div>
                          </td>
                          <td className="w-15">
                             <SelectBox
                                value={inputItem?.correspondentSize}
                                onChange={changeInputCondition}
                                options={correspondentSize}
                                keyValue={'correspondentSize'}
                              />                     
                            {/* <select className='waver-select-box w-100 border-radius-0' value={inputItem.correspondentSize} onChange={(e) => {
                              changeInputCondition('correspondentSize', e.target.value)
                            }}>
                              <option value="nonEligible">{'의무신고 비대상'}</option>
                            </select> */}
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">● 단위지정</td>
                          <td className="w-15">
                            <select className='waver-select-box w-100 border-radius-0' value={inputItem.unit} onChange={(e) => {
                              changeInputCondition('unit', e.target.value)
                            }}>
                              <option value="l">{'ℓ'}</option>
                              <option value="kg">{'kg'}</option>
                            </select>
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">증명서 신고일</td>
                          <td className="w-15">
                            <input className="waver-input-box w-100 border-radius-0" type="date" value={inputItem.certificate_report_date} onChange={(e) => {
                              changeInputCondition('certificate_report_date', e.target.value);
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">신고증명서 번호</td>
                          <td className="w-15">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.certificate_report_number} placeholder="신고증명서 번호" onChange={(e) => {
                              changeInputCondition('certificate_report_number', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">계산서품목내용</td>
                          <td className="w-15">
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.billing_content} placeholder="계산서품목내용" onChange={(e) => {
                              changeInputCondition('billing_content', e.target.value)
                            }} />
                          </td>
                           <td className="w-10 padding-left-8 primary-bg white-text">리포트 발행 여부</td>
                          <td className="w-15">
                            <select className='waver-select-box w-100 border-radius-0' value={inputItem.is_report} onChange={(e) => {
                              changeInputCondition('is_report', e.target.value)
                            }}>
                              <option value="Y">{'발행'}</option>
                              <option value="N">{'미발행'}</option>
                            </select>
                          </td>
                        </tr>                       
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center margin-bottom-12 margin-top-38">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">CMS 정보</p>
          </div>
          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">CMS 회원번호</td>
                          <td className="w-15" colSpan={3}>
                            <input className='waver-input-box w-100 border-radius-0' value={inputItem.CMSNumber} placeholder="CMS 회원번호를 입력해 주세요." onChange={(e) => {
                              changeInputCondition('CMSNumber', e.target.value)
                            }} />
                          </td>                        
                          <td className="w-10 padding-left-8 primary-bg white-text">생년월일 또는 사업자번호</td>
                          <td className="w-15" colSpan={3}>
                            <input type="number" className='waver-input-box w-100 border-radius-0' value={inputItem.CMSBirthAndName} placeholder="생년월일, 사업자" onChange={(e) => {
                              changeInputCondition('CMSBirthAndName', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">은행정보</td>
                          <td className="w-15">
                            <SelectBox
                              value={inputItem?.CMSBank}
                              onChange={changeInputCondition}
                              options={bankList}
                              keyValue={'CMSBank'}
                            />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">예금주</td>
                          <td className="w-15">                            
                            <input className='waver-input-box border-radius-0' value={inputItem.CMSDepositor} placeholder="예금주를 입력해 주세요." onChange={(e) => {
                              changeInputCondition('CMSDepositor', e.target.value)
                            }} />
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">계좌번호</td>
                          <td className="w-40">
                            <input type="number" className='waver-input-box w-100 border-radius-0' value={inputItem.CMSAccountNumber} placeholder="계좌번호를 입력해 주세요." onChange={(e) => {
                              changeInputCondition('CMSAccountNumber', e.target.value)
                            }} />
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">CMS 동의서</td>
                          <td className="w-15" colSpan={3}>
                            <div className="d-flex align-items-center">
                              <input className="d-none" accept=".pdf" type="file" id="cms_file" onChange={(e)=>{
                                registCmsFile(e.target.files)
                              }}/>
                              <label style={{width: 113}} htmlFor="cms_file" type="button" className="custom-btn border-radius-0 tertiary-bg white-text mb-0 text-center">
                                파일 첨부
                              </label>
                              {cmsFile?.[0] ?
                                <p className="mb-0">{cmsFile[0].name}</p>
                                :
                                oldCmsFile?.[0] ? 
                                  <p className="mb-0">{oldCmsFile[0].name}</p>
                                  :
                                  <p className="mb-0"></p>
                              }
                            </div>
                          </td>                        
                          <td className="w-10 padding-left-8 primary-bg white-text"></td>
                          <td className="w-15" colSpan={3}>                            
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div className="d-flex align-items-center margin-bottom-12 margin-top-38">
            <img src={coloredCorrespondent} alt="Help Icon" width={17} height={16} />
            <p className="font-weight-bold font-size-15 mb-0 margin-left-6">메일/SMS 발송 정보</p>
          </div>
          <Row>
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">홈텍스 일괄 메일 발송</td>
                          <td className="w-40">
                            {sendingItem1.map((item, index) => (
                            <div key={"tax_mail_"+index} className={`form-check form-check-inline${index + 1 !== sendingItem1.length ? ' margin-right-20' : ''}`}>
                              <input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom" type="checkbox" id={"tax_mail_"+index} name="tax_mail" checked={inputItem?.tax_mail?.[item.key]  == 'Y'} onChange={(e) => {
                                changeCheckInputCondition('tax_mail', item.key, e.target.checked)
                              }} />
                              <label className="margin-bottom-0 margin-left-8 form-check-label font-size-12 text-black padding-top-5" htmlFor={"tax_mail_"+index}>{item.text}</label>
                            </div>
                            ))}
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">과금용 관리대장 메일 발송</td>
                          <td className="w-40">
                            {sendingItem1.map((item, index) => (
                            <div key={"charge_report_"+index} className={`form-check form-check-inline${index + 1 !== sendingItem1.length ? ' margin-right-20' : ''}`}>
                              <input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom" type="checkbox" id={"charge_report_"+index} name="charge_report" checked={inputItem?.charge_report?.[item.key]  == 'Y'} onChange={(e) => {
                                changeCheckInputCondition('charge_report', item.key, e.target.checked)
                              }} />
                              <label className="margin-bottom-0 margin-left-8 form-check-label font-size-12 text-black padding-top-5" htmlFor={"charge_report_"+index}>{item.text}</label>
                            </div>
                            ))}
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">과금문자 발송</td>
                          <td className="w-40">
                            {sendingItem2.map((item, index) => (
                            <div key={"charge_sms_"+index} className={`form-check form-check-inline${index + 1 !== sendingItem1.length ? ' margin-right-20' : ''}`}>
                              <input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom" type="checkbox" id={"charge_sms_"+index} name="charge_sms" checked={inputItem?.charge_sms?.[item.key]  == 'Y'} onChange={(e) => {
                                changeCheckInputCondition('charge_sms', item.key, e.target.checked)
                              }} />
                              <label className="margin-bottom-0 margin-left-8 form-check-label font-size-12 text-black padding-top-5" htmlFor={"charge_sms_"+index}>{item.text}</label>
                            </div>
                            ))}
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">미수금 문자 발송</td>
                          <td className="w-40">
                            {sendingItem2.map((item, index) => (
                            <div key={"unpaid_sms_"+index} className={`form-check form-check-inline${index + 1 !== sendingItem1.length ? ' margin-right-20' : ''}`}>
                              <input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom" type="checkbox" id={"unpaid_sms_"+index} name="unpaid_sms" checked={inputItem?.unpaid_sms?.[item.key]  == 'Y'} onChange={(e) => {
                                changeCheckInputCondition('unpaid_sms', item.key, e.target.checked)
                              }} />
                              <label className="margin-bottom-0 margin-left-8 form-check-label font-size-12 text-black padding-top-5" htmlFor={"unpaid_sms_"+index}>{item.text}</label>
                            </div>
                            ))}
                          </td>
                        </tr>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">수거알림</td>
                          <td className="w-40">
                            {sendingItem2.map((item, index) => (
                            <div key={"collect_alert_"+index} className={`form-check form-check-inline${index + 1 !== sendingItem1.length ? ' margin-right-20' : ''}`}>
                              <input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom" type="checkbox" id={"collect_alert_"+index} name="collection" checked={inputItem?.collect_alert?.[item.key]  == 'Y'} onChange={(e) => {
                                changeCheckInputCondition('collect_alert', item.key, e.target.checked)
                              }} />
                              <label className="margin-bottom-0 margin-left-8 form-check-label font-size-12 text-black padding-top-5" htmlFor={"collect_alert_"+index}>{item.text}</label>
                            </div>
                            ))}
                          </td>
                          <td className="w-10 padding-left-8 primary-bg white-text">수거알림(수거량 제외)</td>
                          <td className="w-40">
                            {sendingItem2.map((item, index) => (
                            <div key={"collect_alert_exclude_qty_"+index} className={`form-check form-check-inline${index + 1 !== sendingItem1.length ? ' margin-right-20' : ''}`}>
                              <input className="is-untouched is-pristine av-valid form-check-input form-check-input-custom" type="checkbox" id={"collect_alert_exclude_qty_"+index} name="collect_alert_exclude_qty" checked={inputItem?.collect_alert_exclude_qty?.[item.key]  == 'Y'} onChange={(e) => {
                                changeCheckInputCondition('collect_alert_exclude_qty', item.key, e.target.checked)
                              }} />
                              <label className="margin-bottom-0 margin-left-8 form-check-label font-size-12 text-black padding-top-5" htmlFor={"collect_alert_exclude_qty_"+index}>{item.text}</label>
                            </div>
                            ))}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>
          
          <Row className="mt-3">
            <Col xs='12'>
              <div className="email-rightbar">
                <Card className="mb-0">
                  <CardBody className="padding-0">
                    <table className="input-table">
                      <tbody>
                        <tr>
                          <td className="w-10 padding-left-8 primary-bg white-text">거래처 메모</td>
                          <td className="w-90 pb-0">
                            <textarea className="waver-text-box w-100 font-size-12 border-radius-0" placeholder="거래처 메모" value={inputItem.memo}
                            onChange={(e)=>{
                              changeInputCondition('memo', e.target.value);
                            }} />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </CardBody>
                </Card>
              </div>
            </Col>
          </Row>

          <div style={{marginTop: 310}} className="d-flex justify-content-between margin-bottom-25">
            <button style={{width: 178}} type="button" className="custom-btn border-radius-0 dark-bg white-text button-border" onClick={() => {history.push('/contract-management-screen')}}>
              목록으로 이동
            </button>
            <div className="d-flex">
              <button style={{width: 178}} type="button" className="custom-btn border-radius-0 primary-bg white-text button-border" onClick={() => {
                if (isValidated()) {
                  saveCorrespondent()
                }
              }}>
                거래처 수정
              </button>
              <button style={{width: 178}} type="button" className="custom-btn border-radius-0 white-bg primary-text button-border" onClick={() => {
                if(confirm('입력을 초기화 하시겠습니까?')){
                  resetSearchCondition()
                }
              }}>
                입력 초기화
              </button>
            </div>
          </div>
        </Container>
      </div>

      <Modal title={'우편번호 찾기'} show={modalShow.post} onHide={() => {modalClose('post')}} size="md">
        <Post></Post>
      </Modal>

      <Modal title={'우편번호 찾기'} show={modalShow.realPost} onHide={() => {modalClose('realPost')}} size="md">
        <RealPost></RealPost>
      </Modal>

      <Modal title={'처리장 선택'} show={modalShow.treatment} onHide={() => {modalClose('treatment')}} size="md" onSubmit={()=>{}}>
        <div style={{ zIndex: 1,  }}>                
          <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, width: 330, marginBottom : "1rem" }}>
              <input
                className="form-control"
                style={{ backgroundColor: "white", padding: "0.3rem" }}
                placeholder="검색어를 입력해주세요..."
                onChange={(e) => {
                  setSearch(e.target.value.length == 0 ? '' : e.target.value)                        
                }}
                onKeyPress={(e) => {
                  if (e.key == 'Enter') {
                    handleSearch('treatment')
                  }
                }}
              />
              <span onClick={() => {
                handleSearch('treatment')
              }} className="fa fa-search" style={{ lineHeight: '38px', cursor: 'pointer' }} />
            </div>

            <div style={{ position: "relative", minHeight : '300px', overflowY: "auto" }}>
              <div style={{position: "absolute", minHeight : '300px', right: 0, left: 0, overflowX: "hidden"}}>
                {companyList && companyList.map((item) => {
                  return (
                    <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                      onMouseOver={() => {
                        setIsHover(item.id)
                      }}
                      onMouseLeave={() => {
                        setIsHover(false)
                      }}
                      onClick={() => {
                        setCompany(item)
                        modalClose('treatment')
                      }}>{item.name}
                    </div>
                  )
                })}
              </div>
            </div>
        </div>
    </Modal>

    <Modal title={'처리장 선택'} show={modalShow.treatments} onHide={() => {modalClose('treatments')}} size="md" onSubmit={()=>{}}>
        <div style={{ zIndex: 1,  }}>                
          <div className="position-relative app-search d-none d-lg-block" style={{ padding: 0, width: 330, marginBottom : "1rem" }}>
              <input
                className="form-control"
                style={{ backgroundColor: "white", padding: "0.3rem" }}
                placeholder="검색어를 입력해주세요..."
                onChange={(e) => {
                  setSearch(e.target.value.length == 0 ? '' : e.target.value)                        
                }}
                onKeyPress={(e) => {
                  if (e.key == 'Enter') {
                    handleSearch('treatment')
                  }
                }}
              />
              <span onClick={() => {
                handleSearch('treatment')
              }} className="fa fa-search" style={{ lineHeight: '38px', cursor: 'pointer' }} />
            </div>

            <div style={{ position: "relative", minHeight : '300px', overflowY: "auto" }}>
              <div style={{position: "absolute", minHeight : '300px', right: 0, left: 0, overflowX: "hidden"}}>
                {companyList && companyList.map((item) => {
                  return (
                    <div style={isHover == item.id ? { ...style, ...hoverStyle } : { ...style }} key={item.id}
                      onMouseOver={() => {
                        setIsHover(item.id)
                      }}
                      onMouseLeave={() => {
                        setIsHover(false)
                      }}
                      onClick={() => {
                        setCompanies([...companies, companies.map(item => { return item.name }).indexOf(item.name) == -1 && item].filter(item => item != false))
                        modalClose('treatments')
                      }}>{item.name}
                    </div>
                  )
                })}
              </div>
            </div>
        </div>
    </Modal>

    </React.Fragment>
    
  )
}

export default correspondentEdit
